export default __webpack_public_path__ + "static/media/72ab1d98b65785804fb4fb755ac21e78.9109084d.jpeg";